import { useEffect, useState, useRef } from 'react';

const useIdle = (timeout: number = 60000): boolean => {
  const [isIdle, setIsIdle] = useState<boolean>(false);
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resetTimer = () => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    setIsIdle(false);
    timeoutId.current = setTimeout(() => setIsIdle(true), timeout);
  };

  useEffect(() => {
    const events: (keyof WindowEventMap)[] = ['mousemove', 'keydown', 'wheel', 'scroll', 'touchstart'];

    for (let event of events) {
      window.addEventListener(event, resetTimer);
    }

    resetTimer(); // start the timer initially

    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      for (let event of events) {
        window.removeEventListener(event, resetTimer);
      }
    };
  }, [timeout]);

  return isIdle;
};

export default useIdle;
